module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAARCAYAAAAougcOAAABEUlEQVQ4jWM8wsBwiIGBgYmBduADCwMDgxUDAwMzDS35xERjX4DAX5AF/2hsyR8WfLIsamoMBocPM7CLiTEcZWQEi1n//49T/VlnZ4Yf+/ZhmoPPEpX58zHEXu3cycAuKclwRV8fr/ORAc74kJ0zh4FHRYXh6ZIlRBtGkiUcTk4McsnJDHebmii2AKclGrNng4Pl/dSpWDXx6+mB4wYZS/b24rQEI04UV61iYBcXZ7ji6YlT08dLl0iKEwxLhO3tGVi4uRnMb95EEQe59lpODtEGIwOM4DojLg5OrjB8r68PLA5i4wo+ki2hBSBoyfPiYnhGJBeASuE/NC4gX4N8QpkzCQNWUOp6TcO4YWRgYHgLAN8QSRAAlCK7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/yszq/4F.png
// module id = QThD
// module chunks = 0